import React from "react";
import { MapTo } from "@adobe/aem-react-editable-components";
import { ButtonList, TeaserTextProps } from "./TeaserText.types";
import { TeaserTextContainer } from "./TeaserText.style";
import sanitizeHtml from "sanitize-html";
import sanitizeWhiteList from "../sanitize-html.whitelist";
import Button from "../MicroComponents/Button/Button";
import { blankSpace } from "../Hero/Hero";
import { tagCtaClick } from "../../utils/tagManager";

export default function TeaserText({
  id,
  order,
  backgroundColor,
  borderColor,
  isBorder,
  title,
  titleUpper,
  titleColor,
  subtitle,
  subtitleUpper,
  subtitleColor,
  text,
  textColor,
  buttonList,
  image,
  imageAlt,
  imageTitle,
  pageImovelClassSuffix
}: TeaserTextProps) {
  const pageImovelClassName = {
    padding: `page-imovel-${pageImovelClassSuffix}-padding`,
    content: `page-imovel-${pageImovelClassSuffix}-content`,
  }

    const handleTagCtaClick = (text: string, id: string) => {
    tagCtaClick({
      element_text: text,
      element_location: "body",
      content_id: id,
      section_title: title,
    });
  };

  return (
    <TeaserTextContainer
      id={id}
      $order={order}
      $titleColor={titleColor}
      $subtitleColor={subtitleColor}
      $textColor={textColor}
      $titleUpper={titleUpper}
      $subtitleUpper={subtitleUpper}
      $backgroundColor={backgroundColor}
      $borderColor={borderColor}
      $isBorder={isBorder}
      className={pageImovelClassName.padding}
    >
      {title && <h2 className="teaser__title">{title}</h2>}
      <div className="teaser">
        <div className={`teaser__content ${pageImovelClassName.content}`}>
          {subtitle && <h2 className="teaser__subtitle">{subtitle}</h2>}
          {image && pageImovelClassSuffix?.includes("borderless") && (
            <img
              className="teaser__image-borderless"
              src={blankSpace(image)}
              title={imageTitle}
              alt={imageAlt}
            />
          )}
          {text && (
            <div
              className="teaser__text"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(text, sanitizeWhiteList),
              }}
            ></div>
          )}
          {buttonList && buttonList.length > 0 && (
            <div className="teaser__buttons">
              {buttonList.map((item: ButtonList, index: number) => (
                <Button
                  id={item.buttonId}
                  key={index}
                  type={item.buttonType}
                  text={item.buttonText}
                  fontColor={item.buttonTextColor}
                  backgroundColor={item.buttonBackgroundColor}
                  click={() => {
                    window.open(item.buttonLink, item.buttonTarget);
                    handleTagCtaClick(item.buttonText ?? "", item.buttonId);
                  }}
                />
              ))}
            </div>
          )}
        </div>
        {image && (
          <img
            className={`teaser__image image-${pageImovelClassSuffix}`}
            src={blankSpace(image)}
            title={imageTitle}
            alt={imageAlt}
          />
        )}
      </div>
    </TeaserTextContainer>
  );
};
